var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#CrossIcon_svg__clip0_323_18953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.28.22A.75.75 0 00.22 1.28L2.94 4 .22 6.72a.75.75 0 101.06 1.06L4 5.06l2.72 2.72a.75.75 0 101.06-1.06L5.06 4l2.72-2.72A.75.75 0 006.72.22L4 2.94 1.28.22z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "CrossIcon_svg__clip0_323_18953"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h8v8H0z"
  })))));
}
export default SvgCrossIcon;